import { useFormik, useFormikContext } from 'formik';
import React from 'react';

interface iStep {
  label: string;
  isCompleteted: boolean;
  hasError?: boolean;
  subSteps?: {
    label: string;
    isCompleted: boolean;
  }[];
}

const FormikContext = React.createContext({
  values: {},
  setValues: (values: any) => {},
  steps: [] as iStep[],
  setSteps: (steps: iStep[]) => {},
  currentStep: { step: 0, subStep: 0 },
  setCurrentStep: ({ step, subStep }: { step: number; subStep: number }) => {},
  bankCheckData: { inst_num: '', bank_name: '', trans_number: [] } as any,
  setBankCheckData: (data: any) => {},
});

export const FormikContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [values, setValues] = React.useState({});
  const [steps, setSteps] = React.useState<iStep[]>([]);
  const [bankCheckData, setBankCheckData] = React.useState({});
  const [currentStep, setCurrentStep] = React.useState({
    step: 0,
    subStep: 0,
  });

  return (
    <FormikContext.Provider
      value={{
        values,
        setValues,
        currentStep,
        setCurrentStep,
        steps,
        setSteps,
        bankCheckData,
        setBankCheckData,
      }}
    >
      {children}
    </FormikContext.Provider>
  );
};

export default FormikContext;
